export const USE_CORPORATE_BILLING = {
  corporateBilled: {
    key: "corporateBilled",
    label: "Corporate Billed",
  },
};
